import React from 'react';

export default function AppHeader() {
  return (
    <header className='bg-dark py-5'>
      <div className='container px-5'>
        <div className='row gx-5 justify-content-center'>
          <div className='col-lg-6'>
            <div className='text-center my-5'>
              <h1 className='display-5 fw-bolder text-white mb-2'>Michels MFG LLC</h1>
              <p className='lead text-white-50 mb-4'>Established in 2017, We pride ourselves on Quality and On Time Delivery at a fair price. Michels Manufacturing is a women owned and managed, top grade industrial turning and milling machine shop focused on delivering precision and high quality aluminum, stainless steel, chromalloy and plastic products for a select set of diversified industries. Our primary target markets are Aerospace, Military, Medical, and Food Processing suppliers and contractors.</p>
              <p className='lead text-white-50 mb-4'>Michels Manufacturing operation philosophy is to purchase high quality, high production capable equipment to ensure top quality products with low labor to machine ratios. This ensures less manual set up, greatly reducing human error and significantly increasing quality and consistency of products produced. Our collective knowledge of the industry provides us the unique advantage of selecting preferred orders to optimize our labor and machine run times.</p>
              <div className='d-grid gap-3 d-sm-flex justify-content-sm-center'>
                <a className='btn btn-primary btn-lg px-4 me-sm-3' href='#contact'>
                  Contact Us
                </a>
                <a className='btn btn-outline-light btn-lg px-4' href='#features'>
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
